import {
  Box,
  Card,
  CardContent,
  Grid,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemText,
  Alert,
} from '@mui/material';
import { Button, Text } from '@qwickapps/react-framework';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptIcon from '@mui/icons-material/Receipt';
import UpgradeIcon from '@mui/icons-material/Upgrade';

export default function BillingSettings() {
  return (
    <Box>
      <Text variant="h6" gutterBottom customColor="var(--theme-accent-dark)">
        Billing & Subscription
      </Text>
      <Text variant="body2" style={{ marginBottom: '24px' }} customColor="var(--theme-text)">
        Manage your subscription, payment methods, and billing history
      </Text>

      <Divider sx={{ mb: 3 }} />

      {/* Current Plan */}
      <Card variant="outlined" sx={{ mb: 3, borderColor: 'var(--theme-border-main)', bgcolor: 'var(--theme-surface)' }}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Text variant="h6" customColor="var(--theme-text-primary)">Current Plan</Text>
            <Chip
              label="Free Plan"
              size="medium"
              sx={{
                fontWeight: 'bold',
                fontSize: '0.9rem',
                backgroundColor: 'var(--theme-surface)',
                color: 'var(--theme-text-secondary)',
                border: '1px solid var(--theme-border-main)'
              }}
            />
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Text variant="body2" customColor="var(--theme-text-secondary)">
                Monthly Cost
              </Text>
              <Text variant="h5" customColor="var(--theme-text-primary)">$0.00</Text>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Text variant="body2" customColor="var(--theme-text-secondary)">
                Next Billing Date
              </Text>
              <Text variant="body1" customColor="var(--theme-text-primary)">—</Text>
            </Grid>
          </Grid>
          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              startIcon={<UpgradeIcon sx={{ color: 'var(--theme-on-primary)' }} />}
              onClick={() => console.log('Upgrade plan')}
            >
              Upgrade Plan
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* Usage */}
      <Card variant="outlined" sx={{ mb: 3, bgcolor: 'var(--theme-surface)' }}>
        <CardContent>
          <Text variant="h6" gutterBottom customColor="var(--theme-text-primary)">
            Current Usage
          </Text>
          <Alert severity="info" sx={{ mb: 2 }}>
            Track your API usage, token consumption, and resource limits here
          </Alert>
          <List>
            <ListItem>
              <ListItemText
                primary="API Requests"
                secondary="0 / Unlimited this month"
                primaryTypographyProps={{ sx: { color: 'var(--theme-text-primary)' } }}
                secondaryTypographyProps={{ sx: { color: 'var(--theme-text-secondary)' } }}
              />
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <ListItemText
                primary="Tokens Consumed"
                secondary="0 / Unlimited"
                primaryTypographyProps={{ sx: { color: 'var(--theme-text-primary)' } }}
                secondaryTypographyProps={{ sx: { color: 'var(--theme-text-secondary)' } }}
              />
            </ListItem>
            <Divider component="li" />
            <ListItem>
              <ListItemText
                primary="Storage Used"
                secondary="0 MB / 1 GB"
                primaryTypographyProps={{ sx: { color: 'var(--theme-text-primary)' } }}
                secondaryTypographyProps={{ sx: { color: 'var(--theme-text-secondary)' } }}
              />
            </ListItem>
          </List>
        </CardContent>
      </Card>

      {/* Payment Method */}
      <Card variant="outlined" sx={{ mb: 3, bgcolor: 'var(--theme-surface)' }}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Text variant="h6" customColor="var(--theme-text-primary)">Payment Method</Text>
            <Button
              variant="outlined"
              startIcon={<PaymentIcon sx={{ color: 'var(--theme-text-disabled)' }} />}
              size="small"
              disabled
            >
              Add Payment
            </Button>
          </Box>
          <Text variant="body2" customColor="var(--theme-text-secondary)">
            No payment method on file
          </Text>
        </CardContent>
      </Card>

      {/* Billing History */}
      <Card variant="outlined" sx={{ bgcolor: 'var(--theme-surface)' }}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Text variant="h6" customColor="var(--theme-text-primary)">Billing History</Text>
            <Button
              variant="outlined"
              startIcon={<ReceiptIcon sx={{ color: 'var(--theme-text-disabled)' }} />}
              size="small"
              disabled
            >
              Download All
            </Button>
          </Box>
          <Text variant="body2" customColor="var(--theme-text-secondary)">
            No billing history available
          </Text>
        </CardContent>
      </Card>
    </Box>
  );
}
